import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('home');

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className='hero'>
      <div className="hero-content">
        <div className="hero-text">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="button-container">
        <button 
          className="learn-more-button" 
          onClick={() => handleNavigation('/About')}
        >
          {t('discoverMore')}
        </button>
      </div>  
    </div>
  );
};

export { Hero };
export default Hero;
